/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as LoginRouteImport } from './routes/login'
import { Route as MissionsRouteRouteImport } from './routes/missions/route'
import { Route as InitConsoleRouteRouteImport } from './routes/init-console/route'
import { Route as CasesRouteRouteImport } from './routes/cases/route'
import { Route as StaticRouteRouteImport } from './routes/_static/route'
import { Route as MissionIdRouteRouteImport } from './routes/$missionId/route'
import { Route as IndexRouteImport } from './routes/index'
import { Route as InitConsoleIndexRouteImport } from './routes/init-console/index'
import { Route as CasesIndexRouteImport } from './routes/cases/index'
import { Route as MissionIdIndexRouteImport } from './routes/$missionId/index'
import { Route as MissionsMissionIdRouteImport } from './routes/missions/$missionId'
import { Route as CasesSearchRouteImport } from './routes/cases/search'
import { Route as CasesCaseIdRouteImport } from './routes/cases/$caseId'
import { Route as StaticTermsRouteImport } from './routes/_static/terms'
import { Route as StaticPrivacyPolicyRouteImport } from './routes/_static/privacy-policy'
import { Route as StaticLegalNoticeRouteImport } from './routes/_static/legal-notice'
import { Route as StaticDevRouteImport } from './routes/_static/dev'
import { Route as MissionIdSearchRouteImport } from './routes/$missionId/search'
import { Route as MissionIdBookingSummaryRouteImport } from './routes/$missionId/booking-summary'
import { Route as MissionIdSearchResultsSearchIdRouteRouteImport } from './routes/$missionId/search-results/$searchId/route'
import { Route as MissionIdSearchResultsSearchIdIndexRouteImport } from './routes/$missionId/search-results/$searchId/index'
import { Route as MissionIdSearchResultsSearchIdBookingMobilitySolutionIdBookingIdPrimaryIndexRouteImport } from './routes/$missionId/search-results/$searchId/booking/$mobilitySolutionId/$bookingId/primary/index'
import { Route as MissionIdSearchResultsSearchIdBookingMobilitySolutionIdBookingIdPrimaryConfirmationRouteImport } from './routes/$missionId/search-results/$searchId/booking/$mobilitySolutionId/$bookingId/primary/confirmation'
import { Route as MissionIdSearchResultsSearchIdBookingMobilitySolutionIdBookingIdGroundTransferGroundTransferIdRouteImport } from './routes/$missionId/search-results/$searchId/booking/$mobilitySolutionId/$bookingId/ground-transfer/$groundTransferId'

const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const MissionsRouteRoute = MissionsRouteRouteImport.update({
  id: '/missions',
  path: '/missions',
  getParentRoute: () => rootRouteImport,
} as any)
const InitConsoleRouteRoute = InitConsoleRouteRouteImport.update({
  id: '/init-console',
  path: '/init-console',
  getParentRoute: () => rootRouteImport,
} as any)
const CasesRouteRoute = CasesRouteRouteImport.update({
  id: '/cases',
  path: '/cases',
  getParentRoute: () => rootRouteImport,
} as any)
const StaticRouteRoute = StaticRouteRouteImport.update({
  id: '/_static',
  getParentRoute: () => rootRouteImport,
} as any)
const MissionIdRouteRoute = MissionIdRouteRouteImport.update({
  id: '/$missionId',
  path: '/$missionId',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const InitConsoleIndexRoute = InitConsoleIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => InitConsoleRouteRoute,
} as any)
const CasesIndexRoute = CasesIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => CasesRouteRoute,
} as any)
const MissionIdIndexRoute = MissionIdIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => MissionIdRouteRoute,
} as any)
const MissionsMissionIdRoute = MissionsMissionIdRouteImport.update({
  id: '/$missionId',
  path: '/$missionId',
  getParentRoute: () => MissionsRouteRoute,
} as any)
const CasesSearchRoute = CasesSearchRouteImport.update({
  id: '/search',
  path: '/search',
  getParentRoute: () => CasesRouteRoute,
} as any)
const CasesCaseIdRoute = CasesCaseIdRouteImport.update({
  id: '/$caseId',
  path: '/$caseId',
  getParentRoute: () => CasesRouteRoute,
} as any)
const StaticTermsRoute = StaticTermsRouteImport.update({
  id: '/terms',
  path: '/terms',
  getParentRoute: () => StaticRouteRoute,
} as any)
const StaticPrivacyPolicyRoute = StaticPrivacyPolicyRouteImport.update({
  id: '/privacy-policy',
  path: '/privacy-policy',
  getParentRoute: () => StaticRouteRoute,
} as any)
const StaticLegalNoticeRoute = StaticLegalNoticeRouteImport.update({
  id: '/legal-notice',
  path: '/legal-notice',
  getParentRoute: () => StaticRouteRoute,
} as any)
const StaticDevRoute = StaticDevRouteImport.update({
  id: '/dev',
  path: '/dev',
  getParentRoute: () => StaticRouteRoute,
} as any)
const MissionIdSearchRoute = MissionIdSearchRouteImport.update({
  id: '/search',
  path: '/search',
  getParentRoute: () => MissionIdRouteRoute,
} as any)
const MissionIdBookingSummaryRoute = MissionIdBookingSummaryRouteImport.update({
  id: '/booking-summary',
  path: '/booking-summary',
  getParentRoute: () => MissionIdRouteRoute,
} as any)
const MissionIdSearchResultsSearchIdRouteRoute =
  MissionIdSearchResultsSearchIdRouteRouteImport.update({
    id: '/search-results/$searchId',
    path: '/search-results/$searchId',
    getParentRoute: () => MissionIdRouteRoute,
  } as any)
const MissionIdSearchResultsSearchIdIndexRoute =
  MissionIdSearchResultsSearchIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => MissionIdSearchResultsSearchIdRouteRoute,
  } as any)
const MissionIdSearchResultsSearchIdBookingMobilitySolutionIdBookingIdPrimaryIndexRoute =
  MissionIdSearchResultsSearchIdBookingMobilitySolutionIdBookingIdPrimaryIndexRouteImport.update(
    {
      id: '/booking/$mobilitySolutionId/$bookingId/primary/',
      path: '/booking/$mobilitySolutionId/$bookingId/primary/',
      getParentRoute: () => MissionIdSearchResultsSearchIdRouteRoute,
    } as any,
  )
const MissionIdSearchResultsSearchIdBookingMobilitySolutionIdBookingIdPrimaryConfirmationRoute =
  MissionIdSearchResultsSearchIdBookingMobilitySolutionIdBookingIdPrimaryConfirmationRouteImport.update(
    {
      id: '/booking/$mobilitySolutionId/$bookingId/primary/confirmation',
      path: '/booking/$mobilitySolutionId/$bookingId/primary/confirmation',
      getParentRoute: () => MissionIdSearchResultsSearchIdRouteRoute,
    } as any,
  )
const MissionIdSearchResultsSearchIdBookingMobilitySolutionIdBookingIdGroundTransferGroundTransferIdRoute =
  MissionIdSearchResultsSearchIdBookingMobilitySolutionIdBookingIdGroundTransferGroundTransferIdRouteImport.update(
    {
      id: '/booking/$mobilitySolutionId/$bookingId/ground-transfer/$groundTransferId',
      path: '/booking/$mobilitySolutionId/$bookingId/ground-transfer/$groundTransferId',
      getParentRoute: () => MissionIdSearchResultsSearchIdRouteRoute,
    } as any,
  )

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/$missionId': typeof MissionIdRouteRouteWithChildren
  '/cases': typeof CasesRouteRouteWithChildren
  '/init-console': typeof InitConsoleRouteRouteWithChildren
  '/missions': typeof MissionsRouteRouteWithChildren
  '/login': typeof LoginRoute
  '/$missionId/booking-summary': typeof MissionIdBookingSummaryRoute
  '/$missionId/search': typeof MissionIdSearchRoute
  '/dev': typeof StaticDevRoute
  '/legal-notice': typeof StaticLegalNoticeRoute
  '/privacy-policy': typeof StaticPrivacyPolicyRoute
  '/terms': typeof StaticTermsRoute
  '/cases/$caseId': typeof CasesCaseIdRoute
  '/cases/search': typeof CasesSearchRoute
  '/missions/$missionId': typeof MissionsMissionIdRoute
  '/$missionId/': typeof MissionIdIndexRoute
  '/cases/': typeof CasesIndexRoute
  '/init-console/': typeof InitConsoleIndexRoute
  '/$missionId/search-results/$searchId': typeof MissionIdSearchResultsSearchIdRouteRouteWithChildren
  '/$missionId/search-results/$searchId/': typeof MissionIdSearchResultsSearchIdIndexRoute
  '/$missionId/search-results/$searchId/booking/$mobilitySolutionId/$bookingId/ground-transfer/$groundTransferId': typeof MissionIdSearchResultsSearchIdBookingMobilitySolutionIdBookingIdGroundTransferGroundTransferIdRoute
  '/$missionId/search-results/$searchId/booking/$mobilitySolutionId/$bookingId/primary/confirmation': typeof MissionIdSearchResultsSearchIdBookingMobilitySolutionIdBookingIdPrimaryConfirmationRoute
  '/$missionId/search-results/$searchId/booking/$mobilitySolutionId/$bookingId/primary/': typeof MissionIdSearchResultsSearchIdBookingMobilitySolutionIdBookingIdPrimaryIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/missions': typeof MissionsRouteRouteWithChildren
  '/login': typeof LoginRoute
  '/$missionId/booking-summary': typeof MissionIdBookingSummaryRoute
  '/$missionId/search': typeof MissionIdSearchRoute
  '/dev': typeof StaticDevRoute
  '/legal-notice': typeof StaticLegalNoticeRoute
  '/privacy-policy': typeof StaticPrivacyPolicyRoute
  '/terms': typeof StaticTermsRoute
  '/cases/$caseId': typeof CasesCaseIdRoute
  '/cases/search': typeof CasesSearchRoute
  '/missions/$missionId': typeof MissionsMissionIdRoute
  '/$missionId': typeof MissionIdIndexRoute
  '/cases': typeof CasesIndexRoute
  '/init-console': typeof InitConsoleIndexRoute
  '/$missionId/search-results/$searchId': typeof MissionIdSearchResultsSearchIdIndexRoute
  '/$missionId/search-results/$searchId/booking/$mobilitySolutionId/$bookingId/ground-transfer/$groundTransferId': typeof MissionIdSearchResultsSearchIdBookingMobilitySolutionIdBookingIdGroundTransferGroundTransferIdRoute
  '/$missionId/search-results/$searchId/booking/$mobilitySolutionId/$bookingId/primary/confirmation': typeof MissionIdSearchResultsSearchIdBookingMobilitySolutionIdBookingIdPrimaryConfirmationRoute
  '/$missionId/search-results/$searchId/booking/$mobilitySolutionId/$bookingId/primary': typeof MissionIdSearchResultsSearchIdBookingMobilitySolutionIdBookingIdPrimaryIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/$missionId': typeof MissionIdRouteRouteWithChildren
  '/_static': typeof StaticRouteRouteWithChildren
  '/cases': typeof CasesRouteRouteWithChildren
  '/init-console': typeof InitConsoleRouteRouteWithChildren
  '/missions': typeof MissionsRouteRouteWithChildren
  '/login': typeof LoginRoute
  '/$missionId/booking-summary': typeof MissionIdBookingSummaryRoute
  '/$missionId/search': typeof MissionIdSearchRoute
  '/_static/dev': typeof StaticDevRoute
  '/_static/legal-notice': typeof StaticLegalNoticeRoute
  '/_static/privacy-policy': typeof StaticPrivacyPolicyRoute
  '/_static/terms': typeof StaticTermsRoute
  '/cases/$caseId': typeof CasesCaseIdRoute
  '/cases/search': typeof CasesSearchRoute
  '/missions/$missionId': typeof MissionsMissionIdRoute
  '/$missionId/': typeof MissionIdIndexRoute
  '/cases/': typeof CasesIndexRoute
  '/init-console/': typeof InitConsoleIndexRoute
  '/$missionId/search-results/$searchId': typeof MissionIdSearchResultsSearchIdRouteRouteWithChildren
  '/$missionId/search-results/$searchId/': typeof MissionIdSearchResultsSearchIdIndexRoute
  '/$missionId/search-results/$searchId/booking/$mobilitySolutionId/$bookingId/ground-transfer/$groundTransferId': typeof MissionIdSearchResultsSearchIdBookingMobilitySolutionIdBookingIdGroundTransferGroundTransferIdRoute
  '/$missionId/search-results/$searchId/booking/$mobilitySolutionId/$bookingId/primary/confirmation': typeof MissionIdSearchResultsSearchIdBookingMobilitySolutionIdBookingIdPrimaryConfirmationRoute
  '/$missionId/search-results/$searchId/booking/$mobilitySolutionId/$bookingId/primary/': typeof MissionIdSearchResultsSearchIdBookingMobilitySolutionIdBookingIdPrimaryIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/$missionId'
    | '/cases'
    | '/init-console'
    | '/missions'
    | '/login'
    | '/$missionId/booking-summary'
    | '/$missionId/search'
    | '/dev'
    | '/legal-notice'
    | '/privacy-policy'
    | '/terms'
    | '/cases/$caseId'
    | '/cases/search'
    | '/missions/$missionId'
    | '/$missionId/'
    | '/cases/'
    | '/init-console/'
    | '/$missionId/search-results/$searchId'
    | '/$missionId/search-results/$searchId/'
    | '/$missionId/search-results/$searchId/booking/$mobilitySolutionId/$bookingId/ground-transfer/$groundTransferId'
    | '/$missionId/search-results/$searchId/booking/$mobilitySolutionId/$bookingId/primary/confirmation'
    | '/$missionId/search-results/$searchId/booking/$mobilitySolutionId/$bookingId/primary/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/missions'
    | '/login'
    | '/$missionId/booking-summary'
    | '/$missionId/search'
    | '/dev'
    | '/legal-notice'
    | '/privacy-policy'
    | '/terms'
    | '/cases/$caseId'
    | '/cases/search'
    | '/missions/$missionId'
    | '/$missionId'
    | '/cases'
    | '/init-console'
    | '/$missionId/search-results/$searchId'
    | '/$missionId/search-results/$searchId/booking/$mobilitySolutionId/$bookingId/ground-transfer/$groundTransferId'
    | '/$missionId/search-results/$searchId/booking/$mobilitySolutionId/$bookingId/primary/confirmation'
    | '/$missionId/search-results/$searchId/booking/$mobilitySolutionId/$bookingId/primary'
  id:
    | '__root__'
    | '/'
    | '/$missionId'
    | '/_static'
    | '/cases'
    | '/init-console'
    | '/missions'
    | '/login'
    | '/$missionId/booking-summary'
    | '/$missionId/search'
    | '/_static/dev'
    | '/_static/legal-notice'
    | '/_static/privacy-policy'
    | '/_static/terms'
    | '/cases/$caseId'
    | '/cases/search'
    | '/missions/$missionId'
    | '/$missionId/'
    | '/cases/'
    | '/init-console/'
    | '/$missionId/search-results/$searchId'
    | '/$missionId/search-results/$searchId/'
    | '/$missionId/search-results/$searchId/booking/$mobilitySolutionId/$bookingId/ground-transfer/$groundTransferId'
    | '/$missionId/search-results/$searchId/booking/$mobilitySolutionId/$bookingId/primary/confirmation'
    | '/$missionId/search-results/$searchId/booking/$mobilitySolutionId/$bookingId/primary/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  MissionIdRouteRoute: typeof MissionIdRouteRouteWithChildren
  StaticRouteRoute: typeof StaticRouteRouteWithChildren
  CasesRouteRoute: typeof CasesRouteRouteWithChildren
  InitConsoleRouteRoute: typeof InitConsoleRouteRouteWithChildren
  MissionsRouteRoute: typeof MissionsRouteRouteWithChildren
  LoginRoute: typeof LoginRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/missions': {
      id: '/missions'
      path: '/missions'
      fullPath: '/missions'
      preLoaderRoute: typeof MissionsRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/init-console': {
      id: '/init-console'
      path: '/init-console'
      fullPath: '/init-console'
      preLoaderRoute: typeof InitConsoleRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/cases': {
      id: '/cases'
      path: '/cases'
      fullPath: '/cases'
      preLoaderRoute: typeof CasesRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_static': {
      id: '/_static'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof StaticRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/$missionId': {
      id: '/$missionId'
      path: '/$missionId'
      fullPath: '/$missionId'
      preLoaderRoute: typeof MissionIdRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/init-console/': {
      id: '/init-console/'
      path: '/'
      fullPath: '/init-console/'
      preLoaderRoute: typeof InitConsoleIndexRouteImport
      parentRoute: typeof InitConsoleRouteRoute
    }
    '/cases/': {
      id: '/cases/'
      path: '/'
      fullPath: '/cases/'
      preLoaderRoute: typeof CasesIndexRouteImport
      parentRoute: typeof CasesRouteRoute
    }
    '/$missionId/': {
      id: '/$missionId/'
      path: '/'
      fullPath: '/$missionId/'
      preLoaderRoute: typeof MissionIdIndexRouteImport
      parentRoute: typeof MissionIdRouteRoute
    }
    '/missions/$missionId': {
      id: '/missions/$missionId'
      path: '/$missionId'
      fullPath: '/missions/$missionId'
      preLoaderRoute: typeof MissionsMissionIdRouteImport
      parentRoute: typeof MissionsRouteRoute
    }
    '/cases/search': {
      id: '/cases/search'
      path: '/search'
      fullPath: '/cases/search'
      preLoaderRoute: typeof CasesSearchRouteImport
      parentRoute: typeof CasesRouteRoute
    }
    '/cases/$caseId': {
      id: '/cases/$caseId'
      path: '/$caseId'
      fullPath: '/cases/$caseId'
      preLoaderRoute: typeof CasesCaseIdRouteImport
      parentRoute: typeof CasesRouteRoute
    }
    '/_static/terms': {
      id: '/_static/terms'
      path: '/terms'
      fullPath: '/terms'
      preLoaderRoute: typeof StaticTermsRouteImport
      parentRoute: typeof StaticRouteRoute
    }
    '/_static/privacy-policy': {
      id: '/_static/privacy-policy'
      path: '/privacy-policy'
      fullPath: '/privacy-policy'
      preLoaderRoute: typeof StaticPrivacyPolicyRouteImport
      parentRoute: typeof StaticRouteRoute
    }
    '/_static/legal-notice': {
      id: '/_static/legal-notice'
      path: '/legal-notice'
      fullPath: '/legal-notice'
      preLoaderRoute: typeof StaticLegalNoticeRouteImport
      parentRoute: typeof StaticRouteRoute
    }
    '/_static/dev': {
      id: '/_static/dev'
      path: '/dev'
      fullPath: '/dev'
      preLoaderRoute: typeof StaticDevRouteImport
      parentRoute: typeof StaticRouteRoute
    }
    '/$missionId/search': {
      id: '/$missionId/search'
      path: '/search'
      fullPath: '/$missionId/search'
      preLoaderRoute: typeof MissionIdSearchRouteImport
      parentRoute: typeof MissionIdRouteRoute
    }
    '/$missionId/booking-summary': {
      id: '/$missionId/booking-summary'
      path: '/booking-summary'
      fullPath: '/$missionId/booking-summary'
      preLoaderRoute: typeof MissionIdBookingSummaryRouteImport
      parentRoute: typeof MissionIdRouteRoute
    }
    '/$missionId/search-results/$searchId': {
      id: '/$missionId/search-results/$searchId'
      path: '/search-results/$searchId'
      fullPath: '/$missionId/search-results/$searchId'
      preLoaderRoute: typeof MissionIdSearchResultsSearchIdRouteRouteImport
      parentRoute: typeof MissionIdRouteRoute
    }
    '/$missionId/search-results/$searchId/': {
      id: '/$missionId/search-results/$searchId/'
      path: '/'
      fullPath: '/$missionId/search-results/$searchId/'
      preLoaderRoute: typeof MissionIdSearchResultsSearchIdIndexRouteImport
      parentRoute: typeof MissionIdSearchResultsSearchIdRouteRoute
    }
    '/$missionId/search-results/$searchId/booking/$mobilitySolutionId/$bookingId/primary/': {
      id: '/$missionId/search-results/$searchId/booking/$mobilitySolutionId/$bookingId/primary/'
      path: '/booking/$mobilitySolutionId/$bookingId/primary'
      fullPath: '/$missionId/search-results/$searchId/booking/$mobilitySolutionId/$bookingId/primary/'
      preLoaderRoute: typeof MissionIdSearchResultsSearchIdBookingMobilitySolutionIdBookingIdPrimaryIndexRouteImport
      parentRoute: typeof MissionIdSearchResultsSearchIdRouteRoute
    }
    '/$missionId/search-results/$searchId/booking/$mobilitySolutionId/$bookingId/primary/confirmation': {
      id: '/$missionId/search-results/$searchId/booking/$mobilitySolutionId/$bookingId/primary/confirmation'
      path: '/booking/$mobilitySolutionId/$bookingId/primary/confirmation'
      fullPath: '/$missionId/search-results/$searchId/booking/$mobilitySolutionId/$bookingId/primary/confirmation'
      preLoaderRoute: typeof MissionIdSearchResultsSearchIdBookingMobilitySolutionIdBookingIdPrimaryConfirmationRouteImport
      parentRoute: typeof MissionIdSearchResultsSearchIdRouteRoute
    }
    '/$missionId/search-results/$searchId/booking/$mobilitySolutionId/$bookingId/ground-transfer/$groundTransferId': {
      id: '/$missionId/search-results/$searchId/booking/$mobilitySolutionId/$bookingId/ground-transfer/$groundTransferId'
      path: '/booking/$mobilitySolutionId/$bookingId/ground-transfer/$groundTransferId'
      fullPath: '/$missionId/search-results/$searchId/booking/$mobilitySolutionId/$bookingId/ground-transfer/$groundTransferId'
      preLoaderRoute: typeof MissionIdSearchResultsSearchIdBookingMobilitySolutionIdBookingIdGroundTransferGroundTransferIdRouteImport
      parentRoute: typeof MissionIdSearchResultsSearchIdRouteRoute
    }
  }
}

interface MissionIdSearchResultsSearchIdRouteRouteChildren {
  MissionIdSearchResultsSearchIdIndexRoute: typeof MissionIdSearchResultsSearchIdIndexRoute
  MissionIdSearchResultsSearchIdBookingMobilitySolutionIdBookingIdGroundTransferGroundTransferIdRoute: typeof MissionIdSearchResultsSearchIdBookingMobilitySolutionIdBookingIdGroundTransferGroundTransferIdRoute
  MissionIdSearchResultsSearchIdBookingMobilitySolutionIdBookingIdPrimaryConfirmationRoute: typeof MissionIdSearchResultsSearchIdBookingMobilitySolutionIdBookingIdPrimaryConfirmationRoute
  MissionIdSearchResultsSearchIdBookingMobilitySolutionIdBookingIdPrimaryIndexRoute: typeof MissionIdSearchResultsSearchIdBookingMobilitySolutionIdBookingIdPrimaryIndexRoute
}

const MissionIdSearchResultsSearchIdRouteRouteChildren: MissionIdSearchResultsSearchIdRouteRouteChildren =
  {
    MissionIdSearchResultsSearchIdIndexRoute:
      MissionIdSearchResultsSearchIdIndexRoute,
    MissionIdSearchResultsSearchIdBookingMobilitySolutionIdBookingIdGroundTransferGroundTransferIdRoute:
      MissionIdSearchResultsSearchIdBookingMobilitySolutionIdBookingIdGroundTransferGroundTransferIdRoute,
    MissionIdSearchResultsSearchIdBookingMobilitySolutionIdBookingIdPrimaryConfirmationRoute:
      MissionIdSearchResultsSearchIdBookingMobilitySolutionIdBookingIdPrimaryConfirmationRoute,
    MissionIdSearchResultsSearchIdBookingMobilitySolutionIdBookingIdPrimaryIndexRoute:
      MissionIdSearchResultsSearchIdBookingMobilitySolutionIdBookingIdPrimaryIndexRoute,
  }

const MissionIdSearchResultsSearchIdRouteRouteWithChildren =
  MissionIdSearchResultsSearchIdRouteRoute._addFileChildren(
    MissionIdSearchResultsSearchIdRouteRouteChildren,
  )

interface MissionIdRouteRouteChildren {
  MissionIdBookingSummaryRoute: typeof MissionIdBookingSummaryRoute
  MissionIdSearchRoute: typeof MissionIdSearchRoute
  MissionIdIndexRoute: typeof MissionIdIndexRoute
  MissionIdSearchResultsSearchIdRouteRoute: typeof MissionIdSearchResultsSearchIdRouteRouteWithChildren
}

const MissionIdRouteRouteChildren: MissionIdRouteRouteChildren = {
  MissionIdBookingSummaryRoute: MissionIdBookingSummaryRoute,
  MissionIdSearchRoute: MissionIdSearchRoute,
  MissionIdIndexRoute: MissionIdIndexRoute,
  MissionIdSearchResultsSearchIdRouteRoute:
    MissionIdSearchResultsSearchIdRouteRouteWithChildren,
}

const MissionIdRouteRouteWithChildren = MissionIdRouteRoute._addFileChildren(
  MissionIdRouteRouteChildren,
)

interface StaticRouteRouteChildren {
  StaticDevRoute: typeof StaticDevRoute
  StaticLegalNoticeRoute: typeof StaticLegalNoticeRoute
  StaticPrivacyPolicyRoute: typeof StaticPrivacyPolicyRoute
  StaticTermsRoute: typeof StaticTermsRoute
}

const StaticRouteRouteChildren: StaticRouteRouteChildren = {
  StaticDevRoute: StaticDevRoute,
  StaticLegalNoticeRoute: StaticLegalNoticeRoute,
  StaticPrivacyPolicyRoute: StaticPrivacyPolicyRoute,
  StaticTermsRoute: StaticTermsRoute,
}

const StaticRouteRouteWithChildren = StaticRouteRoute._addFileChildren(
  StaticRouteRouteChildren,
)

interface CasesRouteRouteChildren {
  CasesCaseIdRoute: typeof CasesCaseIdRoute
  CasesSearchRoute: typeof CasesSearchRoute
  CasesIndexRoute: typeof CasesIndexRoute
}

const CasesRouteRouteChildren: CasesRouteRouteChildren = {
  CasesCaseIdRoute: CasesCaseIdRoute,
  CasesSearchRoute: CasesSearchRoute,
  CasesIndexRoute: CasesIndexRoute,
}

const CasesRouteRouteWithChildren = CasesRouteRoute._addFileChildren(
  CasesRouteRouteChildren,
)

interface InitConsoleRouteRouteChildren {
  InitConsoleIndexRoute: typeof InitConsoleIndexRoute
}

const InitConsoleRouteRouteChildren: InitConsoleRouteRouteChildren = {
  InitConsoleIndexRoute: InitConsoleIndexRoute,
}

const InitConsoleRouteRouteWithChildren =
  InitConsoleRouteRoute._addFileChildren(InitConsoleRouteRouteChildren)

interface MissionsRouteRouteChildren {
  MissionsMissionIdRoute: typeof MissionsMissionIdRoute
}

const MissionsRouteRouteChildren: MissionsRouteRouteChildren = {
  MissionsMissionIdRoute: MissionsMissionIdRoute,
}

const MissionsRouteRouteWithChildren = MissionsRouteRoute._addFileChildren(
  MissionsRouteRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  MissionIdRouteRoute: MissionIdRouteRouteWithChildren,
  StaticRouteRoute: StaticRouteRouteWithChildren,
  CasesRouteRoute: CasesRouteRouteWithChildren,
  InitConsoleRouteRoute: InitConsoleRouteRouteWithChildren,
  MissionsRouteRoute: MissionsRouteRouteWithChildren,
  LoginRoute: LoginRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
